import * as RadixPopover from "@radix-ui/react-popover";
import cx from "classnames";
import type { FC, ForwardRefRenderFunction, RefAttributes } from "react";
import { forwardRef } from "react";

const PopoverRoot: FC<RadixPopover.PopoverProps> = ({ children, modal: modalRaw, ...props }) => {
	const modal = modalRaw === undefined ? false : modalRaw;
	return (
		<RadixPopover.Root modal={modal} {...props}>
			{children}
		</RadixPopover.Root>
	);
};

const PopoverTrigger: ForwardRefRenderFunction<
	HTMLButtonElement,
	RadixPopover.PopoverTriggerProps & RefAttributes<HTMLButtonElement>
> = ({ children, ...props }, ref) => {
	return (
		<RadixPopover.Trigger ref={ref} {...props}>
			{children}
		</RadixPopover.Trigger>
	);
};

const PopoverContent: ForwardRefRenderFunction<
	HTMLDivElement,
	RadixPopover.PopoverContentProps & RefAttributes<HTMLDivElement>
> = ({ children, sideOffset = 8, ...props }, ref) => {
	return (
		<RadixPopover.Content
			{...props}
			ref={ref}
			sideOffset={sideOffset}
			className={cx(
				"z-popover data-[side=bottom]:animate-slideDownAndFade data-[side=left]:animate-slideRightAndFade data-[side=right]:animate-slideLeftAndFade data-[side=top]:animate-slideUpAndFade",
				"rounded shadow-lg"
			)}
		>
			<div
				className={`rounded bg-primary-raised p-4 text-sm shadow-border-default ${props.className}`}
			>
				{children}
			</div>
		</RadixPopover.Content>
	);
};

export const Popover = {
	Root: PopoverRoot,
	Trigger: forwardRef(PopoverTrigger),
	Anchor: RadixPopover.Anchor,
	Portal: RadixPopover.Portal,
	Content: forwardRef(PopoverContent),
	Close: RadixPopover.Close,
	Arrow: RadixPopover.Arrow,
};
